<template>
    <div class="root_info_user">
        <div class="root_video_live" style="margin-top: 30px;">
            <h2 class="title_category title_category0"><font-awesome-icon icon="fa-solid fa-video" /> <span>{{ name }}</span></h2>
            <div class="row" v-if="listVideo.length > 0">
                <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" v-for="(item, index) in listVideo" :key="index">
                    <div class="item_live">
                        <router-link v-bind:to="{ name: 'VideoPlay_nm', params: { id: item.id } }">
                            <div class="img_live img_live_video">
                                <img :src="item.thumbnail" alt="">
                            </div>
                        </router-link>
                    </div>
                    <div class="text_video_preview">
                        <router-link v-bind:to="{ name: 'VideoPlay_nm', params: { id: item.id } }">
                            <h3>{{ item.title }}</h3>
                            <p>{{ item.description }}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <ul class="pagination_page">
                <li v-for="(link, index) in getVisibleLinks(listLinks)" :key="index" :class="['page-item', { active: link.active, disabled: !link.url && link.label !== '...' }]">
                    <router-link
                        v-if="link.url"
                        to="/video"
                        class="page-link"
                        v-html="link.label"
                        @click.prevent="loadPage(link.url)"
                    ></router-link>
                    <span v-else class="page-link" v-html="link.label"></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CatVideo_nm',
    data () {
        return {
            listVideo: [],
            page: 1,
            limit: 15,
            listLinks: [],
            id: parseInt(this.$route.params.id),
            name: ''
        }
    },
    components: {
    },
    created () {
        this.getListVideo()
        this.getListCatVideo()
    },
    computed: {
        
    },
    methods: {
        getListCatVideo () {
            this.axios.get(this.api_linkCatVideo,
                {
                    headers: {
                        'x-api-key': 'your-secret-api-key-123'
                    }
                }
            ).then((response) => {
                this.name = response.data.categories.filter(d=>d.id == this.id)[0].name
            })
        },
        getListVideo () {
            this.axios.get(this.api_linkVideo + '?page=' + this.page + '&limit=' + this.limit + '&category=' + this.id,
                {
                    headers: {
                        'x-api-key': 'your-secret-api-key-123'
                    }
                }
            ).then((response) => {
                this.listVideo = response.data.data
                this.listLinks = response.data.links
            })
        },
        getVisibleLinks(links) {
            const visible = [];
            const numberedLinks = links.filter(link => !isNaN(link.label));
            if (numberedLinks.length === 0) {
                return links;
            }
            const current = numberedLinks.find(link => link.active);
            const currentPage = current ? parseInt(current.label) : 1;
            const first = 1;
            const last = parseInt(numberedLinks[numberedLinks.length - 1]?.label || 1);
            visible.push(links[0]);
            for (let i = first; i <= last; i++) {
                if (i === first || i === last || Math.abs(i - currentPage) <= 1) {
                    const realLink = numberedLinks.find(l => parseInt(l.label) === i);
                    if (realLink) visible.push(realLink);
                } else {
                    const lastItem = visible[visible.length - 1];
                    if (lastItem && lastItem.label !== '...') {
                        visible.push({ label: '...', url: null, active: false });
                    }
                }
            }
            visible.push(links[links.length - 1]);
            return visible;
        },
        loadPage (url) {
            const urlObj = new URL(url);
            const pageParam = urlObj.searchParams.get('page');
            this.page = Number(pageParam) || 1;
            this.getListVideo()
        }
    }
}
</script>